<template>
  <!--选择兑换码弹框-->
  <van-popup v-model="popupShow" round position="bottom" :style="{ height: height }" class="choose-popup" @close="close">
    <div class="choose-popup-wrap">
      <div class="popup-header">
        {{ title }}<i class="van-icon van-icon-cross van-action-sheet__close" @click="close"><!----></i>
      </div>
      <div class="base-cell" @click="show = true">
        <div class="base-cell-value">
          <div class="base-cell-body">
            <input type="text" placeholder="请输入" class="base-field-control" v-model="inputValue" :maxlength="maxlength" ref="refInput" />
            <div class="base-cell-word-limit">
              <span class="base-cell-word-num">{{ inputNum }}</span
              >/{{ maxlength }}
            </div>
          </div>
        </div>
      </div>
      <van-divider />
      <!--快速查找标签-->
      <div class="labelList" v-if="labelList.length">
        <div class="labelList-title">快速选择</div>
        <div class="labelList-content">
          <span
            class="label ellipsis"
            v-for="(item, index) in labelList"
            :key="index"
            :class="{ active: activeLabel === index }"
            @click="setLabel(index)"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="button btn-blue" @click="submit">保存</div>
    </div>
  </van-popup>
</template>

<script>
import { checkEmojiRule } from '../utils';
import Toast from 'vant/es/toast';

export default {
  name: 'singleInputPop',
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 5,
    },
    require: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: 'auto',
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  mounted() {
    this.inputValue = this.value ? this.value : ''
  },
  data() {
    return {
      inputValue: '',
      activeLabel: '', //快速选择标签
    }
  },
  computed: {
    inputNum: {
      get() {
        return this.inputValue.length || 0
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    popupShow: {
      get() {
        if(this.show){
          this.$nextTick(()=>{
            this.$refs.refInput.focus()
          })
        }
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  methods: {
    close() {
      this.inputValue = ''
      this.$emit('update:show', false)
    },
    submit() {
      if(this.require && !this.inputValue.trim()){
        Toast(`${this.title}不能为空`)
        return
      }
      // name校验
      if(this.name === 'name'){
        let reg = /^[a-zA-Z\u4e00-\u9fa5]+$/g;
        if(!reg.test(this.inputValue.trim())){
          Toast('真实姓名请输入中文或字母')
          return
        }
      }
      if(checkEmojiRule(this.inputValue)){
        Toast('不能输入表情')
        return
      }
      this.$emit('onSubmit', this.inputValue)
      this.close()
    },
    // 设置标签
    setLabel(index) {
      this.activeLabel = index
      this.inputValue = this.labelList[this.activeLabel]
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-picker__toolbar {
  margin-top: 10px;
}
/deep/ .van-picker__title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 18px;
  margin-left: 25px;
}
/deep/ .van-picker__confirm {
  color: #000000;
}
/deep/ .van-picker__columns {
  margin-top: 30px;
}
/deep/ .van-action-sheet__close {
  padding: 0;
}
.choose-popup {
  width: 100%;
  padding: 0 20px;
  .choose-popup-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: content-box;
    /*padding-bottom: 70px;*/
  }
  .popup-header {
    padding: 20px 0;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: @darkBlack;
    .van-action-sheet__close {
      top: 20px;
    }
  }
  // 最近出的input 应用在弹框里
  .base-cell {
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    background: #ffffff;
    padding: 0;
    .base-cell-title {
      flex: none;
      box-sizing: border-box;
      margin-right: 16px;
      text-align: left;
      color: @darkBlack;
    }
    .base-cell-value {
      flex: 1;
      position: relative;
      overflow: hidden;
      color: #969799;
      vertical-align: middle;
      word-wrap: break-word;
      .vip-cell-body {
        display: flex;
        text-align: center;
        align-items: center;
      }
      .base-cell-word-limit {
        margin: 20px 0;
        color: @subBlack;
        font-size: 14px;
        text-align: right;
        .base-cell-word-num {
          color: @baseBlue;
        }
      }
    }
    .base-field-control {
      display: block;
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      margin: 0;
      padding: 0;
      color: #323233;
      line-height: inherit;
      text-align: left;
      background-color: transparent;
      border: 0;
      resize: none;
    }
  }
  .button {
    margin: 10px 0px 20px 0px;
    box-shadow: none;
  }
  .labelList {
    margin-top: 31px;
    .labelList-title {
      font-size: 16px;
      color: @darkBlack;
      font-weight: 500;
    }
    .labelList-content {
      display: flex;
      flex-wrap: wrap;
      max-height: 176px;
      overflow-y: scroll;
      margin: 18px 0px 0px 0px;
      .label {
        width: 105px;
        margin: 0px 8.5px 10px 0px;
        background: #f8f8f8;
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        color: @darkBlack;
      }
      .label:nth-child(3n + 3) {
        margin-right: 0;
      }
      .label.active {
        border: none;
        background: #ebf3ff;
        color: @blue;
        box-shadow: none;
      }
    }
  }
}
</style>
